<template>
  <div class="NewsSearch">

    <text-input class="NewsSearch-searchInput"
      ref="input"
      :class="{ 'NewsSearch-searchInput--isHidden': search.show }"
      placeholder="Search news"
      @focus="focus"
      @submit="submit"
      v-model="input"
      large />

    <search-tray
      title="News search"
      :results="results"
      :max-results="50"
      results-label="posts"
      anchor-right>

      <text-input
        slot="input"
        placeholder="Search news"
        @submit="submit"
        v-model="input"
        large />

      <template scope="result">

        <news-search-result :data="result" />

      </template>

    </search-tray>

  </div>
</template>

<script>
import { assign, orderBy, isFunction } from 'lodash'

export default {
  name: 'NewsSearch',

  components: {
    // Lazy-load components
    NewsSearchResult: () => import('components/async/NewsSearchResult'),
    SearchTray: () => import('components/async/SearchTray')
  },

  data () {
    return {
      /**
       * Search field input
       * @type {String}
       */
      input: '',

      /**
       * Holds the news search index (loaded on search field focus)
       * @type {Object, Boolean}
       */
      index: false
    }
  },

  computed: {
    search () { return this.$store.state.search },

    /**
     * Results, ordered by date
     * @return {Array}
     */
    results () {
      const results = []

      // Push date into results
      this.search.results.forEach(result => {
        results.push(assign(result, {
          date: this.search.index.documentStore.docs[result.ref].date
        }))
      })

      return orderBy(this.search.results, ['date'], ['desc'])
    }
  },

  watch: {
    'search.search' () {
      this.input = this.search.search

      // Add search query to URL
      this.$router.replace({
        query: { search: this.search.search }
      })
    },

    'search.show' () {
      if (this.search.show) return
      this.focusInput()
      this.$router.replace({
        query: {}
      })
    }
  },

  async created () {
    // If the URL contains a search query, start search
    if (this.$route.query.search) {
      this.performSearch(this.$route.query.search)
    }
  },

  methods: {
    /**
     * Wait to load search index until search field is focused
     */
    async focus () {
      // Exit if index is already loaded
      if (this.index) return

      // Load the search index
      this.loadSearchIndex()
    },

    /**
     * Show the search tray
     */
    submit () {
      if (!this.input) return
      this.performSearch(this.input)
    },

    /**
     * Load the search index file
     */
    async loadSearchIndex () {
      const index = await import('app/.generated/search/news.json')
      this.$store.dispatch('search/setData', index)
    },

    /**
     * Perform a search
     * @param {String} input
     */
    async performSearch (input) {
      // Clear search results
      this.$store.dispatch('search/setResults', [])

      // Make sure the search index has loaded
      if (!isFunction(this.search.index)) {
        await this.loadSearchIndex()
      }

      // Open the search tray
      this.$store.dispatch('search/show')

      // Perform search
      // - Waits a tick to make sure previous results are cleared
      this.$nextTick(() => {
        this.$store.dispatch('search/search', {
          term: input.trim(),
          opts: {
            fields: {
              title: { boost: 1 },
              description: { boost: 1 },
              content: { boost: 1 }
            },
            bool: 'AND',
            expand: false
          }
        })
      })
    },

    /**
     * Focus on search input
     */
    focusInput () {
      if (!this.$refs.input) return
      this.$refs.input.$el.querySelector('input').focus()
    }
  }
}
</script>

<style>
.NewsSearch {

}
</style>



// WEBPACK FOOTER //
// NewsSearch.vue?0ee50ad4